import React, { useState, useEffect } from 'react';
import axios from '../../../axiosInstance'; // Custom Axios instance
import './Profile.css'; // External CSS for styles
import Sidebar from '../Sidebar/Sidebar';

function Profile() {
  const [profileData, setProfileData] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const reporterId = localStorage.getItem('reporterId'); // Retrieve reporterId from local storage
  const token = localStorage.getItem('sessiontoken'); // Retrieve session token from local storage

    // Fetch profile data from the API
    useEffect(() => {
      axios
        .get(`/api/reporter?reporterId=${reporterId}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          const reporter = response.data.reporter;
    
          setProfileData(reporter);
          setLoading(false);
        })
        .catch((err) => {
          console.error('Error fetching profile data:', err);
          setError('Failed to load profile data.');
          setLoading(false);
        });
    }, [reporterId, token]);

  return (
    <div>
      <Sidebar />
      <div className="profile-container">
        {loading ? (
          <p>Loading ....</p>
        ) : error ? (
          <p className="error">{error}</p>
        ) : (
          <div className="profile-page">
            <div className="profile-header">
              <div className="profile-header-left">
                {/* {profileImage ? (
                  <img
                    src={profileData.profileImage} // Base64 string to be used as the image source
                    alt="Profile"
                    className="profile-img"
                  />
                ) : (
                  <p>Loading image...</p>
                )} */}

                <div className="profile-info">
                  <h2>
                    {profileData.firstName} {profileData.lastName}
                  </h2>
                  <p>{profileData.email}</p>
                  <p>{profileData.mobileNumber}</p>
                  <p>
                    {profileData.district}, {profileData.state}, {profileData.pincode}
                  </p>
                  <p>Repoter Id - {profileData.reporterId}</p>
                </div>
              </div>
            </div>

            <PasswordUpdateForm />
          </div>
        )}
      </div>
    </div>
  );
}

function PasswordUpdateForm() {
  const [passwordData, setPasswordData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
    reporterId: '', // Add reporterId to the state
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const token = localStorage.getItem('token'); // Retrieve session token from local storage

  const reporterId = localStorage.getItem('reporterId') || ''; // Ensure reporterId is available

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPasswordData({ ...passwordData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate the new password and confirm password match
    if (passwordData.newPassword !== passwordData.confirmPassword) {
      setError('New password and confirm password do not match.');
      setSuccess('');
      return;
    }

    // Clear previous error and success messages
    setError('');
    setSuccess('');

    const dataToSubmit = {
      ...passwordData,
      reporterId: reporterId, // Attach reporterId to the request body
    };

    // Send the password update request
    axios
      .put('/api/reporter/password', dataToSubmit, {
        headers: {
          Authorization: `Bearer ${token}`, // Attach the token in the Authorization header
        },
      })
      .then((response) => {
        setSuccess('Password updated successfully.');
        setPasswordData({
          currentPassword: '',
          newPassword: '',
          confirmPassword: '',
        });
      })
      .catch((err) => {
        console.error('Error updating password:', err);
        setError('Failed to update password. Please try again.');
      });
  };

  return (
    <div className="password-update-form">
      <h3>Change Password</h3>
      <form onSubmit={handleSubmit}>
        <input
          type="password"
          name="currentPassword"
          value={passwordData.currentPassword}
          onChange={handleChange}
          placeholder="Current Password"
        />
        <input
          type="password"
          name="newPassword"
          value={passwordData.newPassword}
          onChange={handleChange}
          placeholder="New Password"
        />
        <input
          type="password"
          name="confirmPassword"
          value={passwordData.confirmPassword}
          onChange={handleChange}
          placeholder="Confirm Password"
        />
        <input
          type="hidden"
          name="reporterId"
          value={reporterId}
        />
        {error && <p className="error">{error}</p>}
        {success && <p className="success">{success}</p>}
        <button type="submit">Update Password</button>
      </form>
    </div>
  );
}

export default Profile;
